/**
 * Lead quality UI: crown threshold from server-injected window.chatwootConfig.
 */
export function leadQualityCrownThreshold() {
  if (typeof window === 'undefined') return 50;
  const v = window.chatwootConfig?.leadQualityCrownThreshold;
  const n = Number(v);
  return Number.isFinite(n) ? n : 50;
}

export function leadQualityScoreFromMetadata(meta) {
  if (!meta || typeof meta !== 'object') return null;
  const s = meta.lead_quality_score ?? meta['lead_quality_score'];
  if (s == null || s === '') return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

export function leadQualityReasonsFromMetadata(meta) {
  if (!meta || typeof meta !== 'object') return '';
  return String(meta.reasons ?? meta['reasons'] ?? '').trim();
}

export function shouldShowLeadQualityCrown(meta, threshold = null) {
  const score = leadQualityScoreFromMetadata(meta);
  const t = threshold != null ? Number(threshold) : leadQualityCrownThreshold();
  const thr = Number.isFinite(t) ? t : 50;
  return score != null && score > thr;
}
